
            const data = {"name":"suggested","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M4 2h8c.368 0 .666.298.667.667v10.797L8.53 10.878a1 1 0 0 0-.935-.066l-.125.066-4.136 2.586V2.667C3.334 2.299 3.632 2 4 2Z\" _stroke=\"#81889B\" stroke-width=\"1.333\"/>","originalColors":[{"type":"stroke","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    